import PropTypes from 'prop-types'
import React from 'react'
import px from 'add-px'
import classNames from 'classnames'
import './Space.css'

const Space = ({ value = 0, type = 'vertical' }) => {
  const styles = {}
  if (type === 'horizontal') {
    styles.width = px(value)
  } else {
    styles.height = px(value)
  }

  const classes = classNames({
    Space: true,
    [`Space--${type}`]: true
  })

  return <div className={classes} style={styles} />
}

Space.defaultProps = {
  value: 0,
  type: 'vertical'
}

Space.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default Space
